import { FindUserSection, PaginationSection } from '@app/shared/ui/organisms/Admin/Common';
import { ListSection } from '@app/shared/ui/organisms/Admin/Users';
import { WeekPicker } from '@app/shared/ui/organisms/Common';
import { RadioGroup } from '@app/shared/ui/molecules/Admin/Common';
import { useFindUser } from '@app/shared/hooks/admin/useFindUser';
import { usePaginationSearchParams } from '@app/shared/hooks/usePaginationSearchParams';
import { getUsers } from '@app/pages/admin/usersMockData';
import { BALANCE_OPTIONS } from '@app/shared/constants/admin/balance';
import { UserFilters } from '@app/shared/types/admin/pages/users';
import { FindUserFilters } from '@app/shared/types/admin/common';
import { PriceType } from '@app/shared/types/common';

const PAGE_SIZE = 10;

export default function AdminUsersPage() {
  const { searchParams, page, handleSearchParamsChange, handlePrevPage, handleNextPage } =
    usePaginationSearchParams<UserFilters & FindUserFilters>();
  const date = new Date(Number(searchParams.get('date')) || Date.now());
  const balanceType = searchParams.get('balanceType') as PriceType;

  const { findUserBy, handleFindUserByChange, findUserValue, handleFindUserValueChange } =
    useFindUser({ searchParams, updateSearchParams: handleSearchParamsChange });

  const { items: users, total: totalUsers } = getUsers({
    findUserBy,
    findUserValue,
    balanceType,
    page,
    limit: PAGE_SIZE,
  });
  const totalPages = Math.ceil(totalUsers / PAGE_SIZE);

  const handleBalanceTypeChange = (value: PriceType) => {
    handleSearchParamsChange({ balanceType: value });
  };

  const handleDateChange = (value?: Date) => {
    handleSearchParamsChange({ date: value?.getTime() });
  };

  return (
    <div className="flex flex-col gap-2">
      <FindUserSection
        findUserBy={findUserBy}
        onFindUserByChange={handleFindUserByChange}
        findUserValue={findUserValue}
        onFindUserValueChange={handleFindUserValueChange}
      />

      <div className="flex items-center justify-center gap-4">
        <WeekPicker selectedDate={date} onSelectedDateChange={handleDateChange} />
        <RadioGroup
          items={BALANCE_OPTIONS}
          value={balanceType}
          onValueChange={handleBalanceTypeChange}
        />
      </div>

      <PaginationSection
        page={page}
        totalPages={totalPages}
        onPrevPage={handlePrevPage}
        onNextPage={() => handleNextPage(totalPages)}
      />

      <ListSection users={users} />
    </div>
  );
}
